import { render, staticRenderFns } from "./AIChatMessages.vue?vue&type=template&id=05ce0dbd&scoped=true"
import script from "./AIChatMessages.vue?vue&type=script&lang=js"
export * from "./AIChatMessages.vue?vue&type=script&lang=js"
import style0 from "./AIChatMessages.vue?vue&type=style&index=0&id=05ce0dbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ce0dbd",
  null
  
)

export default component.exports